"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMatrixTimeOptionRow = exports.StyledMatrixNumberInput = exports.StyledMatrixSelectOptionRow = exports.StyledMatrixMatrixCell = exports.StyledMatrixRadiobutton = exports.StyledMatrixSelectOptionButtonWrapper = exports.StyledMatrixRow = exports.StyledMatrixCol = exports.StyledMatrix = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const MatrixCell_1 = require("../MatrixCell/MatrixCell");
const Button_1 = require("../../../Button");
const controls_1 = require("../../../controls");
const helpers_1 = require("../../../helpers");
const OPTION_ROW_CSS = (0, styled_components_1.css) `
    height: ${helpers_1.SPACING_XL};
    align-items: center;
`;
exports.StyledMatrix = styled_components_1.default.div `
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
`;
exports.StyledMatrixCol = styled_components_1.default.div ``;
exports.StyledMatrixRow = styled_components_1.default.div `
    display: flex;
`;
exports.StyledMatrixSelectOptionButtonWrapper = styled_components_1.default.div ``;
exports.StyledMatrixRadiobutton = (0, styled_components_1.default)(controls_1.Radiobutton) ``;
exports.StyledMatrixMatrixCell = (0, styled_components_1.default)(MatrixCell_1.MatrixCell) ``;
exports.StyledMatrixSelectOptionRow = (0, styled_components_1.default)(exports.StyledMatrixRow) `
    margin-top: ${helpers_1.SPACING_M};
    margin-bottom: ${helpers_1.SPACING_S};
    display: flex;

    ${OPTION_ROW_CSS}

    ${exports.StyledMatrixMatrixCell} {
        margin-right: ${helpers_1.SPACING_S};
    }

    ${exports.StyledMatrixRadiobutton} {
        margin-right: ${helpers_1.SPACING_L};
    }

    ${exports.StyledMatrixSelectOptionButtonWrapper} {
        margin-left: auto;
        order: 2;

        ${Button_1.Button.selector} {
            & + ${Button_1.Button.selector} {
                margin-left: ${helpers_1.SPACING_XL};
            }
        }
    }
`;
exports.StyledMatrixNumberInput = (0, styled_components_1.default)(controls_1.NumberInput) ``;
exports.StyledMatrixTimeOptionRow = (0, styled_components_1.default)(exports.StyledMatrixRow) `
    ${({ disabled, theme }) => (0, styled_components_1.css) `
        color: ${disabled ? theme.colorTextButtonDisabled : theme.colorTextMain};
    `}

    ${exports.StyledMatrixNumberInput} {
        margin: 0 ${helpers_1.SPACING_S};
    }

    ${OPTION_ROW_CSS}
`;
//# sourceMappingURL=Matrix.styles.js.map